import React, { useState, useEffect } from 'react';
//import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './Adminbank.css';
//import { ApiBanks } from '../api/api';
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  InputNumber,
  Checkbox,
  notification,
  message,
} from 'antd';
import {
  getBanks,
  updateBank,
  deleteBank,
  changeBankVisible,
  bankConstruct,
  createBank,
  addNewNews,
  testRefreshTokin,
} from '../api/api';

//Для Добавить банк - объект для построения пустой формы

import Secret from './Secret-name';
import { nanoid } from 'nanoid';
//import { findConfigFile } from 'typescript';
//import { Link, Route } from 'react-router-dom';

let objFrame: any = {};

const AdminBank = () => {
  //Для показа модалки изменения
  const [isModalVisible, setIsModalVisible] = useState(false);
  // для показа модалки удалить?
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);

  const [isModalNewsVisible, setIsModalNewsVisible] = useState(false);
  //для обновления списка банков
  const [banksUpdate, setBanksUpdate] = useState(false);
  //Один банк для вывода всех полей
  const [data, setData] = useState<any>({});
  //Все банки
  const [bankData, setBankData] = useState([]);
  //ID банка
  const [bankID, setBankID] = useState();
  //Объект хранит все checkBox значения, на которые нажали
  const arrCheck: any = {};

  //для отправки измененных значений из формы
  const [form] = Form.useForm();

  const key = 'updatable';

  useEffect(() => {
    bankConstruct().then((res) => {
      objFrame = res;
    });
  }, []);

  const getBanksFunc = () => {
    getBanks()
      .then((res) => {
        if (res.ok) {
          message.success('Банки получены');
          res.json().then((res) => {
            setBankData(res);
          });
        } else {
          res.status === 401
            ? testRefreshTokin().then((res) => {
                getBanksFunc();
              })
            : null;
          if (res.status === 500) throw 'Что-то пошло не так';
        }
      })
      .catch(() => {
        message.error('Что-то пошло не так');
      });
    //Если обновился этот параметр то обновляет список банков
  };
  //для вызова всех банков, а также Resresh старого токена
  useEffect(() => {
    getBanksFunc();
  }, [banksUpdate]);
  //Для модалки изменения
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };
  //............................

  //для модалки удалить
  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    setIsModalDeleteVisible(false);
    deleteBank(bankID)
      .then((res) => res.json())
      .then((res) => {
        res === 'Банк успешно удален!'
          ? notification.open({ message: res })
          : message.error({ content: 'Что-то пошло не так', key, duration: 1 });
        if (banksUpdate) setBanksUpdate(false);
        else setBanksUpdate(true);
      })
      .catch((res) => message.error({ content: 'Что-то пошло не так', key, duration: 1 }));
    form.resetFields();
  };
  const handleCancelDelete = () => {
    setIsModalDeleteVisible(false);
  };
  //............................

  //для модалки добавить новость
  const showModalNews = () => {
    setIsModalNewsVisible(true);
  };

  const handleCancelAddNews = () => {
    setIsModalNewsVisible(false);
    form.resetFields();
  };

  const onFinishNews = (values: any) => {
    addNewNews(values)
      .then((res) => res.json())
      .then((res) => {
        res === 'Новость успешно добавлена!'
          ? notification.open({ message: res })
          : message.error({ content: 'Что-то пошло не так', key, duration: 1 });
      })
      .catch((res) => message.error({ content: 'Что-то пошло не так', key, duration: 1 }));
    form.resetFields();
    setIsModalNewsVisible(false);
  };
  //...........................

  //для изменения visible (показывать/не показывать) банк
  const changeVisible = (e: any) => {
    changeBankVisible(e.target.id, { visible: e.target.checked })
      .then((res) => {
        e.target.checked === true
          ? notification.open({ message: 'Банк виден всем' })
          : notification.open({ message: 'Банк успешно скрыт' });
      })
      .catch((res) => message.error({ content: 'Что-то пошло не так', key, duration: 1 }));
  };

  //вызывется для ввода изменений в банки
  const onFinish = (values: any) => {
    Object.assign(values, arrCheck); // объект с значениями checkbox

    if (Object.keys(values).length) {
      if (data.id === 'createBank') {
        createBank(values)
          .then((res) => res.json())
          .then((res) => {
            res === 'Новый банк успешно добавлен!'
              ? notification.open({ message: res })
              : message.error({ content: 'Что-то пошло не так', key, duration: 1 });
          })
          .catch((res) => notification.open({ message: 'что то пошло не так' }));
      } else {
        updateBank(values, bankID)
          .then((res) => res.json())
          .then((res) => {
            res === 'Банк успешно изменен!'
              ? notification.open({ message: res })
              : message.error({ content: 'Что-то пошло не так', key, duration: 1 });
          })
          .catch((res) => message.error({ content: 'Что-то пошло не так', key, duration: 1 }));
      }

      setIsModalVisible(false);
      form.resetFields();
      //для обновления списка банков после изменения одного из них
      if (banksUpdate) setBanksUpdate(false);
      else setBanksUpdate(true);
    } else {
      message.error({ content: 'Что-то пошло не так', key, duration: 1 });
    }
  };
  //..................................

  //Создание объекта для измененных checkbox - ов
  const checkboxArrConstructor = (checkVal: any) => {
    arrCheck[checkVal.target.name] = checkVal.target.checked;
  };

  //пока в разработке...
  const onFinishFailed = (err: any) => {
    message.error({ content: 'Форма не прошла валидацию', key, duration: 1 });
  };
  return (
    <section className="section__admin">
      <div className="item__wrap-button-new-bank">
        <Button
          type="default"
          className="item__button-new-bank"
          onClick={() => {
            //вызов скелета для создания модалки для "создание банка"
            setData(objFrame);
            showModal();
          }}
        >
          Добавить банк
        </Button>

        <Button
          type="default"
          className="item__button-new-bank"
          onClick={() => {
            //вызов Формы новостей
            showModalNews();
          }}
        >
          Добавить новость
        </Button>
      </div>
      <div className="wrapper__admin">
        {
          //для отображения все банков
          bankData.map((bank) => {
            return (
              <div key={bank['id']} className="item__wrapper-admin">
                <div className="item__admin-title">{bank['title']['type']}</div>

                <Form.Item label="Показывать">
                  <Checkbox
                    defaultChecked={bank['visible']}
                    id={bank['id']}
                    name={'visible' + bank['id']}
                    onChange={changeVisible}
                  />
                </Form.Item>

                <div className="item__admin-cotent">
                  {/* ectionecti onectionectionec tionection ectione ctionectio nectionecti onectionectio nection ection ection ectionection */}
                </div>
                <div className="item__admin-modal">
                  <Button
                    type="primary"
                    onClick={() => {
                      setData(bank);
                      setBankID(bank['id']);
                      showModal();
                    }}
                  >
                    Изменить
                  </Button>
                  <Button
                    type="default"
                    className="item__button"
                    onClick={() => {
                      setBankID(bank['id']);
                      showModalDelete();
                    }}
                  >
                    Удалить
                  </Button>
                </div>
              </div>
            );
          })
        }
      </div>

      <Modal
        key={data?.id}
        title="Форма Создания/Изменения"
        open={isModalVisible}
        afterClose={() => {
          //выполняется когда модалка закрывается
          //Для очистки data для создания полей и внесенных в них значений
          setData('');
        }}
        onOk={form.submit}
        onCancel={handleCancel}
      >
        <Form onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off" form={form}>
          {
            //массив для сооздания модалки изменения
            Object.entries(data).map((value: any) => {
              const key = nanoid();
              if (value[1]['title'] && value[0] !== 'changing_date') {
                if (Object.keys(value[1])[1] === 'filter') {
                  return (
                    <div key={key}>
                      <Form.Item
                        key={value[0]}
                        label={value[1]['title'] + '(Да/Нет)?'}
                        name={value[0]}
                      >
                        <Checkbox
                          defaultChecked={value[1]['filter']}
                          onChange={checkboxArrConstructor}
                          name={value[0]}
                        />
                      </Form.Item>
                      <Form.Item
                        rules={[
                          {
                            max: 480,
                            message: 'Превышено кол-во символов(макс. 480)',
                          },
                        ]}
                        label="Комментарий"
                        key={value[0] + '_c'}
                        name={value[0] + '_c'}
                        className="item__form-labels-comment"
                        initialValue={value[1]['comment']}
                      >
                        <Input.TextArea />
                      </Form.Item>
                    </div>
                  );
                } else if (Object.keys(value[1])[1] === 'num') {
                  return (
                    <div key={key}>
                      <Form.Item
                        key={value[0]}
                        label={value[1]['title']}
                        name={value[0]}
                        className="item__form-labels"
                        initialValue={value[1]['num']}
                      >
                        <InputNumber min="0" />
                      </Form.Item>
                      <Form.Item
                        rules={[
                          {
                            max: 480,
                            message: 'Превышено кол-во символов(макс. 480)',
                          },
                        ]}
                        label="Комментарий"
                        key={value[0] + '_c'}
                        name={value[0] + '_c'}
                        className="item__form-labels-comment"
                        initialValue={value[1]['comment']}
                      >
                        <Input.TextArea />
                      </Form.Item>
                    </div>
                  );
                } else if (value[0] === 'overstatement') {
                  return (
                    <div key={key}>
                      <Form.Item
                        key={value[0]}
                        label={value[1]['title']}
                        name={value[0]}
                        className="item__form-labels"
                        initialValue={value[1]['type']}
                      >
                        <Select>
                          <Select.Option value=""> </Select.Option>
                          <Select.Option value="x2">x2</Select.Option>
                          <Select.Option value="x3">x3</Select.Option>
                          <Select.Option value="x5">x5</Select.Option>
                          <Select.Option value="Запрещено">Запрещено</Select.Option>
                        </Select>
                      </Form.Item>
                      <Form.Item
                        rules={[
                          {
                            max: 480,
                            message: 'Превышено кол-во символов(макс. 480)',
                          },
                        ]}
                        label="Комментарий"
                        key={value[0] + '_c'}
                        name={value[0] + '_c'}
                        className="item__form-labels-comment"
                        initialValue={value[1]['comment']}
                      >
                        <Input.TextArea />
                      </Form.Item>
                    </div>
                  );
                } else if (Object.keys(value[1])[1] === 'type') {
                  if (value[0] === 'title') {
                    return (
                      <div key={key}>
                        <Form.Item
                          rules={[
                            // {
                            //   required: isModalVisible,
                            //   message: 'Поле обязательно для заполнения',
                            // },
                            {
                              max: 50,
                              min: 3,
                              message: 'Введите от 3 до 50 символов в названии',
                            },
                          ]}
                          label={value[1]['title'] + '( ОБЯЗАТЕЛЬНО! )'}
                          key={value[0]}
                          name={value[0]}
                          className="item__form-labels-comment"
                          initialValue={value[1]['type']}
                        >
                          <Input />
                        </Form.Item>
                      </div>
                    );
                  } else {
                    return (
                      <div key={key}>
                        <Form.Item
                          label={value[1]['title']}
                          key={value[0]}
                          name={value[0]}
                          className="item__form-labels-comment"
                          initialValue={value[1]['type']}
                        >
                          <Input />
                        </Form.Item>
                      </div>
                    );
                  }
                }
              }
            })
          }
        </Form>
      </Modal>
      <Modal
        key={data?.id + 'D'}
        title="Форма удаления"
        open={isModalDeleteVisible}
        afterClose={() => {
          //модалка для удаления
          setData('');
        }}
        onOk={handleOkDelete}
        onCancel={handleCancelDelete}
      >
        <h3>Вы уверены?</h3>
      </Modal>

      <Modal
        key={'addNews'}
        title="Форма создания новости"
        open={isModalNewsVisible}
        onOk={form.submit}
        onCancel={handleCancelAddNews}
      >
        <Form
          onFinish={onFinishNews}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            rules={[
              {
                max: 50,
                message: 'Превышено кол-во символов(макс. 50)',
              },
            ]}
            label="Тема( ОБЯЗАТЕЛЬНО! )"
            key="newsTitle"
            name="title"
            className="item__form-labels"
          >
            <Input />
          </Form.Item>
          <Form.Item
            rules={[
              {
                max: 1500,
                message: 'Превышено кол-во символов(макс. 1500)',
              },
            ]}
            label="Содержание( ОБЯЗАТЕЛЬНО! )"
            key="newsContent"
            name="text_news"
            className="item__form-labels"
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
      {localStorage.role === '93260' ? <Secret /> : null}
    </section>
  );
};

export default AdminBank;
